import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Images/Gourob-2.png";
import { HiOutlineHome } from "react-icons/hi";
import { FaFileDownload } from "react-icons/fa";
// import { RiContactsBookLine, RiProfileLine, RiUser2Line } from "react-icons/ri";

const Navbar = () => {
    const { pathname } = useLocation();
    const [activeSection, setActiveSection] = useState("projects");

    //scroll start
    const [y, setY] = useState(window.scrollY);
    const [nav, setNav] = useState(true);

    useEffect(() => {
        const handleNavigation = (e) => {
            const window = e.currentTarget;
            if (y > window.scrollY) {
                setNav(true); // Scrolling up
            } else if (y < window.scrollY) {
                setNav(false); // Scrolling down
            }
            setY(window.scrollY);
        };

        window.addEventListener("scroll", handleNavigation);
        return () => {
            window.removeEventListener("scroll", handleNavigation);
        };
    }, [y]);

    useEffect(() => {
        if (pathname.includes("projectDetails")) {
            return;
        }

        const sectionIds = ["projects", "about", "contact"];

        const handleActiveSection = () => {
            const scrollPosition = window.scrollY + 160;
            let current = sectionIds[0];

            sectionIds.forEach((id) => {
                const section = document.getElementById(id);
                if (section && section.offsetTop <= scrollPosition) {
                    current = id;
                }
            });

            setActiveSection(current);
        };

        handleActiveSection();
        window.addEventListener("scroll", handleActiveSection);

        return () => {
            window.removeEventListener("scroll", handleActiveSection);
        };
    }, [pathname]);

    const getNavLinkClass = (sectionName) => {
        return activeSection === sectionName
            ? "nav-link nav-link-active"
            : "nav-link";
    };

    const onButtonClick = () => {
        // using Java Script method to get PDF file
        fetch("/Resume.pdf").then((response) => {
            response.blob().then((blob) => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = "Gourob_Resume.pdf";
                alink.click();
            });
        });
    };

    return (
        <div
            className={
                nav === true
                    ? "sticky top-0 z-50 shadow-xl backdrop-blur bg-slate-900/95"
                    : "shadow-xl bg-slate-900/95"
            }
        >
            <div className="navbar text-white max-w-[1200px] mx-auto px-2 sm:px-3">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label
                            tabIndex={0}
                            className="btn btn-ghost btn-square text-orange-300 lg:hidden"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h8m-8 6h16"
                                />
                            </svg>
                        </label>
                        <ul
                            tabIndex={0}
                            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-slate-900 rounded-box w-52"
                        >
                            {pathname.includes("projectDetails") ? (
                                <li className="text-yellow-50 justify-end font-semibold hover:text-orange-400">
                                    <Link to="/">
                                        Home
                                        <HiOutlineHome className="text-xl" />
                                    </Link>
                                </li>
                            ) : (
                                <>
                                    <li className="font-semibold">
                                        <a
                                            href="#projects"
                                            className={getNavLinkClass("projects")}
                                        >
                                            Projects
                                        </a>
                                    </li>
                                    <li className="font-semibold">
                                        <a
                                            href="#about"
                                            className={getNavLinkClass("about")}
                                        >
                                            About
                                        </a>
                                    </li>
                                    <li className="font-semibold">
                                        <a
                                            href="#contact"
                                            className={getNavLinkClass("contact")}
                                        >
                                            Contact
                                        </a>
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>
                    <Link to="/">
                        <img className="w-16 sm:w-20" src={logo} alt="logo" />
                    </Link>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal p-0 gap-5">
                        {pathname.includes("projectDetails") ? (
                            <li className="text-yellow-50 justify-end font-semibold hover:text-orange-400">
                                <Link to="/">
                                    Home
                                    <HiOutlineHome className="text-xl" />
                                </Link>
                            </li>
                        ) : (
                            <>
                                <li className="font-semibold">
                                    <a
                                        href="#projects"
                                        className={getNavLinkClass("projects")}
                                    >
                                        Projects
                                    </a>
                                </li>
                                <li className="font-semibold">
                                    <a
                                        href="#about"
                                        className={getNavLinkClass("about")}
                                    >
                                        About
                                    </a>
                                </li>
                                <li className="font-semibold">
                                    <a
                                        href="#contact"
                                        className={getNavLinkClass("contact")}
                                    >
                                        Contact
                                    </a>
                                </li>
                            </>
                        )}
                    </ul>
                </div>
                <div className="navbar-end gap-2">
                    {/* {!pathname.includes("projectDetails") && (
                        <a href="#contact" className="btn-brand-secondary hidden md:inline-flex">
                            Hire Me
                        </a>
                    )} */}
                    <button
                        onClick={onButtonClick}
                        className="btn-brand-primary px-2.5 py-2 text-sm sm:px-4 sm:py-2"
                    >
                        <span>Resume</span>
                        <FaFileDownload className="sm:ml-2" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
